export class IsoWeekDateRangeHelper {
  constructor() {
    this.calculateWeeks();
  }

  todayStartUtc = '';
  currentWeekLabel = '';
  currentWeekNumber = 0;
  currentWeekStartUtc = '';
  currentWeekEndUtc = '';
  // Week display properties
  week1Label = '';
  week2Label = '';
  week1Number = 0;
  week2Number = 0;
  // also store UTC start/end for requests
  week1StartUtc = '';
  week1EndUtc = '';
  week2StartUtc = '';
  week2EndUtc = '';

  private calculateWeeks(): void {
    const todayUtc = this.utcToday();
    this.todayStartUtc = todayUtc.toISOString();

    const day = todayUtc.getUTCDay(); // 0 = Sunday, 1 = Monday, ..., 6 = Saturday
    const startOfCurrentWeek = this.addDaysUTC(todayUtc, -(day === 0 ? 6 : day - 1));
    const endOfCurrentWeek = new Date(this.addDaysUTC(startOfCurrentWeek, 7).getTime() - 1);
    const startOfWeek1 = this.addDaysUTC(startOfCurrentWeek, 7);
    const endOfWeek1 = new Date(this.addDaysUTC(startOfWeek1, 7).getTime() - 1);

    const startOfWeek2 = this.addDaysUTC(startOfWeek1, 7);
    const endOfWeek2 = new Date(this.addDaysUTC(startOfWeek2, 7).getTime() - 1);

    this.currentWeekLabel = this.formatWeekRange(startOfCurrentWeek, endOfCurrentWeek);
    this.currentWeekNumber = this.getIsoWeekNumber(startOfCurrentWeek);
    this.currentWeekStartUtc = startOfCurrentWeek.toISOString();
    this.currentWeekEndUtc = endOfCurrentWeek.toISOString();
    this.week1Label = this.formatWeekRange(startOfWeek1, endOfWeek1);
    this.week2Label = this.formatWeekRange(startOfWeek2, endOfWeek2);

    // Weeks now start on Monday; compute ISO week numbers from the Monday date.
    this.week1Number = this.getIsoWeekNumber(startOfWeek1);
    this.week2Number = this.getIsoWeekNumber(startOfWeek2);

    this.week1StartUtc = startOfWeek1.toISOString();
    this.week1EndUtc = endOfWeek1.toISOString();
    this.week2StartUtc = startOfWeek2.toISOString();
    this.week2EndUtc = endOfWeek2.toISOString();
  }

  private utcToday(): Date {
    const now = new Date();
    return new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()));
  }

  private addDaysUTC(d: Date, days: number): Date {
    return new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate() + days));
  }

  private readonly monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  private formatWeekRange(start: Date, end: Date): string {
    if (start.getUTCMonth() === end.getUTCMonth()) {
      // e.g. May 17-23
      return `${this.monthNames[start.getUTCMonth()]} ${start.getUTCDate()}-${end.getUTCDate()}`;
    }
    // e.g. May 29-Jun 6
    return `${this.monthNames[start.getUTCMonth()]} ${start.getUTCDate()}-${this.monthNames[end.getUTCMonth()]} ${end.getUTCDate()}`;
  }

  private getIsoWeekNumber(date: Date = new Date()): number {
    const d = new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate()));
    // Move to Thursday of the current ISO week
    d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
    const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
    return Math.ceil(((d.getTime() - yearStart.getTime()) / 86400000 + 1) / 7);
  }
}
